import { render, staticRenderFns } from "./pit-detail.vue?vue&type=template&id=aa344e34&"
import script from "./pit-detail.vue?vue&type=script&lang=js&"
export * from "./pit-detail.vue?vue&type=script&lang=js&"
import style0 from "./pit-detail.vue?vue&type=style&index=0&id=aa344e34&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports